module.exports = __webpack_public_path__ + "assets/LawEnforcement.41ad64c1.svg";